/*
 * Copyright (c) 2023 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightTextCompare_Report.js
 *
 * Description:	The class containing the functionality required for the text compare differences report.
 * 
 */

// The text compare report object.
var g_oTextCompare_Report = {};

(function () {
	"use strict";

	/**
	 * Text Compare Report Object.
	 */
	function TextCompareReport() {};

	/**
	 * Prints the differences report.
	 */
	TextCompareReport.prototype.printDifferencesReport = function () {

		// Lock the screen.
		lockScreen();

		// Determine the time zone to be used.
		var iDateTimeZone = (new Date).getTimezoneOffset();

		// Generate the differences report object to be uploaded.
		var oDifferencesReportData = g_oTextCompareReport.generateDifferencesReportObject();

		// Create Server Call for the data.
		var oJSON = {
			timeZone: iDateTimeZone,
			dateFormat: g_oSettings.c_szDateFormat,
			reportData: oDifferencesReportData
		};

		// Call the server to create the differences report.
		$.post({
			url: "TextTools/PrintDifferencesReport",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				if (oResponse.Success) {
					window.open(JSON.parse(oResponse.Contents), "_blank");
				}
				else {
					g_oGreenlightMessages.displayErrorBubble(displayErrorContentHTML(oResponse.Errors));
				}
			},
			error: function () {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szPrintAnnotationsFailed);
			}
		})
		.always(function () {
			unlockScreen();
		});
	};

	/**
	 * Generates the differences report object.
	 */
	TextCompareReport.prototype.generateDifferencesReportObject = function () {

		// Get the number of each type of difference.
		var iTotalDifferences = g_oTextCompare.countDifferences(null, null, null);
		var iAdditionDifferences = g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.Addition, null);
		var iDeletionDifferences = g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.Deletion, null);
		var iSubstitutionDifferences = g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.Substitution, null);
		iSubstitutionDifferences += g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.WeightSubstitution, null);
		iSubstitutionDifferences += g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.StyleSubstitution, null);
		iSubstitutionDifferences += g_oTextCompare.countDifferences(null, g_oTextCompare.eDifferenceTypes.WeightStyleSubstitution, null);

		// Get the number of each status type.
		var iInitialDifferences = g_oTextCompare.countDifferences(null, null, g_oTextCompare.eDifferenceStatuses.Initial);
		var iIgnoredDifferences = g_oTextCompare.countDifferences(null, null, g_oTextCompare.eDifferenceStatuses.Ignore);
		var iAcceptedDifferences = g_oTextCompare.countDifferences(null, null, g_oTextCompare.eDifferenceStatuses.Accept);
		var iRejectedDifferences = g_oTextCompare.countDifferences(null, null, g_oTextCompare.eDifferenceStatuses.Reject);

		// Build the differences report object.
		return {
			ApprovalDocumentName: g_oViewer.g_oArtworkViewer.g_oDoc.documentName,
			CompareDocumentName: g_oCompare.g_oCompareViewer.g_oDoc.documentName,
			ComparisonAccuracy: g_oTextCompare.g_iAccuracy,
			CaseSensitivity: g_oTextCompare.g_iCaseSensitivity,
			BoldItalicDetection: g_oTextCompare.g_iBoldItalicDetection,
			WhitespaceDetection: g_oTextCompare.g_iWhitespaceDetection,
			DifferenceTotals: {
				TotalDifferences: iTotalDifferences,
				TotalAdditions: iAdditionDifferences,
				TotalDeletions: iDeletionDifferences,
				TotalSubstitutions: iSubstitutionDifferences
			},
			StatusTotals: {
				TotalInitial: iInitialDifferences,
				TotalIgnored: iIgnoredDifferences,
				TotalAccepted: iAcceptedDifferences,
				TotalRejected: iRejectedDifferences
			},
			DifferenceGroups: g_oTextCompareReport.generateDifferenceGroupsReportObject()
		}
	};

	/**
	 * Generates the differences report group object.
	 */
	TextCompareReport.prototype.generateDifferenceGroupsReportObject = function () {

		// Outline the list to be returned.
		var oGroupDifferenceGroupReportObjects = [];

		// Get the highest text selection group.
		var iHighestTextSelectionGroup = g_oTextCompare.getHighestTextSelectionGroup(true, true);

		// Loop through each of the sections up to the highest.
		for (var i = 1; i <= iHighestTextSelectionGroup; i++) {

			// Generate the difference object for this group.
			oGroupDifferenceGroupReportObjects.push(g_oTextCompareReport.generateDifferenceGroupReportObject(i));
		}

		// Return the list.
		return oGroupDifferenceGroupReportObjects;
	};

	/**
	 * Generates the difference group report object.
	 * @param {int} iGroupOrder - The group order.
	 */
	TextCompareReport.prototype.generateDifferenceGroupReportObject = function (iGroupOrder) {

		// Outline the difference group object to be populated.
		var oDifferenceGroupObject = {
			GroupOrder: iGroupOrder,
			DifferencesTotal: g_oTextCompare.countDifferences(iGroupOrder, null, null),
			Differences: [],
			ApprovalDifferencePages: [],
			ApprovalDifferenceWords: [],
			ApprovalDifferenceCharacters: [],
			CompareDifferencePages: [],
			CompareDifferenceWords: [],
			CompareDifferenceCharacters: []
		};

		// Get the approval group for the order.
		var oApprovalSectionGroup = g_oTextCompare.getTextSelectionGroupFromOrder(iGroupOrder, false);

		// Get the comapre group for the order.
		var oCompareSectionGroup = g_oTextCompare.getTextSelectionGroupFromOrder(iGroupOrder, true);

		// If we have failed to calculate differences.
		if (oApprovalSectionGroup == null || oCompareSectionGroup == null) {

			// Add that we have failed to calculate the differences.
			oDifferenceGroupObject.Differences.push({
				DifferenceOrder: 1,
				DifferenceType: g_oTextCompare.eDifferenceTypes.FailedToCalculate,
				DifferenceStatus: g_oTextCompare.eDifferenceStatuses.Reject,
				DifferenceText: "",
				SubstitutionDifferenceText: ""
			});
		}
		// If we have no differences.
		else if (oApprovalSectionGroup.g_oTextDifferences.length == 0) {

			// Add that we have no differences.
			oDifferenceGroupObject.Differences.push({
				DifferenceOrder: 1,
				DifferenceType: g_oTextCompare.eDifferenceTypes.NoDifference,
				DifferenceStatus: g_oTextCompare.eDifferenceStatuses.Accept,
				DifferenceText: "",
				SubstitutionDifferenceText: ""
			});
		}
		// If we have calculated differences.
		else {

			// Loop through each of the differences for the group.
			for (var i = 0; i < oApprovalSectionGroup.g_oTextDifferences.length; i++) {

				// Add the difference.
				oDifferenceGroupObject.Differences.push({
					DifferenceOrder: oApprovalSectionGroup.g_oTextDifferences[i].g_iDifferenceOrder,
					DifferenceType: oApprovalSectionGroup.g_oTextDifferences[i].g_eDifferenceType,
					DifferenceStatus: oApprovalSectionGroup.g_oTextDifferences[i].g_iDifferenceStatus,
					DifferenceText: oApprovalSectionGroup.g_oTextDifferences[i].g_oFormattedDifferenceText[0],
					SubstitutionDifferenceText: g_oTextCompare.differenceTypeIsSubstitution(oApprovalSectionGroup.g_oTextDifferences[i].g_eDifferenceType) ? oApprovalSectionGroup.g_oTextDifferences[i].g_oFormattedDifferenceText[1] : ""
				});
			}
		}

		// If we have approval text selections.
		if (oApprovalSectionGroup != null) {

			// Loop through each of the selections for the approval group.
			for (var i = 0; i < oApprovalSectionGroup.g_oTextSelections.length; i++) {

				// Add the page number if missing.
				if (oDifferenceGroupObject.ApprovalDifferencePages.indexOf(oApprovalSectionGroup.g_oTextSelections[i].g_iPage) == -1) {
					oDifferenceGroupObject.ApprovalDifferencePages.push(oApprovalSectionGroup.g_oTextSelections[i].g_iPage);
				}

				// If we are at a word accuracy level.
				if (g_oTextCompare.g_iAccuracy == g_oTextCompare.eAccuracyLevels.Word) {

					// Loop through each of the words in the selection.
					for (var j = 0; j < oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords.length; j++) {

						// Add the approval difference word.
						oDifferenceGroupObject.ApprovalDifferenceWords.push({
							Content: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].content,
							DifferenceType: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].status,
							Bold: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].bold,
							Italic: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].italic,
							EndOfSelection: (j + 1 == oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionWords.length)
						});
					}
				}
				// If we are at a character accuracy level.
				else {

					// Loop through each of the characters in the selection.
					for (var j = 0; j < oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters.length; j++) {

						// Add the approval difference character.
						oDifferenceGroupObject.ApprovalDifferenceCharacters.push({
							Content: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].content,
							DifferenceType: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].status,
							Bold: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].bold,
							Italic: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].italic,
							EndOfWord: oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].lastInWord,
							EndOfSelection: (j + 1 == oApprovalSectionGroup.g_oTextSelections[i].g_oSelectionCharacters.length)
						});
					}
				}
			}
		}

		// If we have compare text selections.
		if (oCompareSectionGroup != null) {

			// Loop through each of the difference words for the compare group.
			for (var i = 0; i < oCompareSectionGroup.g_oTextSelections.length; i++) {

				// Add the page number if missing.
				if (oDifferenceGroupObject.CompareDifferencePages.indexOf(oCompareSectionGroup.g_oTextSelections[i].g_iPage) == -1) {
					oDifferenceGroupObject.CompareDifferencePages.push(oCompareSectionGroup.g_oTextSelections[i].g_iPage);
				}

				// If we are at a word accuracy level.
				if (g_oTextCompare.g_iAccuracy == g_oTextCompare.eAccuracyLevels.Word) {

					// Loop through each of the words in the selection.
					for (var j = 0; j < oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords.length; j++) {

						// Add the compare difference word.
						oDifferenceGroupObject.CompareDifferenceWords.push({
							Content: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].content,
							DifferenceType: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].status,
							Bold: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].bold,
							Italic: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords[j].italic,
							EndOfSelection: (j + 1 == oCompareSectionGroup.g_oTextSelections[i].g_oSelectionWords.length)
						});
					}
				}
				// If we are at a character accuracy level.
				else {

					// Loop through each of the characters in the selection.
					for (var j = 0; j < oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters.length; j++) {

						// Add the compare difference character.
						oDifferenceGroupObject.CompareDifferenceCharacters.push({
							Content: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].content,
							DifferenceType: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].status,
							Bold: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].bold,
							Italic: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].italic,
							EndOfWord: oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters[j].lastInWord,
							EndOfSelection: (j + 1 == oCompareSectionGroup.g_oTextSelections[i].g_oSelectionCharacters.length)
						});
					}
				}
			}
		}

		// Return the populated object.
		return oDifferenceGroupObject;
	};

	// Add the Text Compare UI object to the window.
	window.TextCompareReport = TextCompareReport;
}());